export abstract class AppEvent<T> {
  abstract type: string;
  abstract payload: T;
}
